<script>
  import DataTable from './DataTable.svelte';
  import Pagination from './Pagination.svelte';
  import { paginate } from '../lib/inventory.js';
  export let rows = []; export let caption = ''; export let size = 8;
  let page = 1; let search = '';
  $: filtered = rows.filter(row => !search || Object.values(row).some(value => String(value ?? '').toLowerCase().includes(search.toLowerCase())));
  $: result = paginate(filtered, page, size);
</script>
<div class="paged-table"><label>Filtrar {caption}<input type="search" bind:value={search} on:input={() => page = 1} /></label><DataTable rows={result.rows} {caption} /><p class="muted">{result.first}–{result.last} de {result.total} registros</p><Pagination page={result.page} totalPages={result.totalPages} onChange={value => page = value} label={'Paginación de ' + caption} /></div>
